import styled from 'styled-components';
import triangle from './triangle.svg';
export const Wrap = styled.div`
    display: grid;
    gap: 24px; 
    grid-template-columns: repeat(2, 1fr);
    grid-auto-flow: row;
}
  & > * {
    flex-basis: 50%;
    flex-shrink: 1;
  }
`;

export const Plate = styled.div`
  padding: 24px;
  border-radius: 20px;
  background: #fff;
  &:hover {
    box-shadow: 0px 12px 24px 0px rgba(57, 78, 127, 0.2);
  }
`;

export const Title = styled.div`
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px;
  ${Plate}:hover & {
    color: #985eff;
  }
  &:after {
    content: '';
    display: inline;
    width: 24px;
    height: 24px;
    background: url(${triangle}) no-repeat center right;
    position: relative;
    padding: 0px 31px 0 0;
  }
`;

export const FactoidWrap = styled.div``;

export const Number = styled.span`
  padding: 4px 16px;
  border-radius: 6px;
  background: #f4f5f6;
  font-size: 30px;
  font-weight: 700;
  line-height: 40px;
`;

export const Label = styled.span`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;

export const Text = styled.div`
  color: rgba(9, 21, 38, 0.6);
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
`;

export const WebinarPlate = styled.div`
  border-radius: 16px;
  background: #f5f6f7;
  padding: 16px 16px 24px 16px;
`;

export const WebinarDate = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  margin-bottom: 4px;
`;

export const WebinarTitle = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
